import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icons19 } from "../../../../../icons/Icons19";
import { TrailingIcon14 } from "../../../../../icons/TrailingIcon14";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AdultosCardDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const handleButtonBack = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
  };

  return (
    <div className="adultos-card-details">
      <div className="div-9">
        <div className="frame-61">
          {/* <div className="status-bar">
            <div className="bars-status-default">
              <div className="action">
                <div className="text-wrapper-56">9:50</div>
              </div>

              <img
                className="container"
                alt="Container"
                src="/img/container.png"
              />
            </div>
          </div> */}

          <div className="panel-panel-primary">
            <div className="title-5">Card details</div>

            <div
              className="highlighted-button"
              style={{ marginLeft: 12, marginTop: 15, position: "absolute" }}
              onClick={handleButtonBack}
            >
              <svg
                width={24}
                height={25}
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.9998 11.2998H7.82979L13.4198 5.7098L11.9998 4.2998L3.99979 12.2998L11.9998 20.2998L13.4098 18.8898L7.82979 13.2998H19.9998V11.2998Z"
                  fill={colors.primario}
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="overlap-12">
          <div className="frame-62">
            <div
              className="debit"
              style={{
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                backgroundImage: colors.url_card
                  ? `url(${colors.url_card})`
                  : "none",
                backgroundColor: colors.url_card ? "transparent" : "#9ca3af",
              }}
            >
              <div className="overlap-group-18">
                {/* <img className="group-11" alt="Group" src="/img/group.png" />

                <img className="group-12" alt="Group" src="/img/group-2.png" /> */}

                <div className="frame-63">
                  <div className="frame-64">
                    <div className="text-wrapper-57">Available</div>

                    <div className="frame-65">
                      <div className="frame-66">
                        <div className="frame-67">
                          <div className="text-wrapper-58">13,000</div>

                          <div className="text-wrapper-59">.23</div>
                        </div>

                        <div className="text-wrapper-60">USD</div>
                      </div>

                      <Icons19 className="img-4" color="white" />
                    </div>
                  </div>

                  <div className="frame-68">
                    <div className="text-wrapper-57">Assigned</div>

                    <div className="frame-69">
                      <div className="frame-67">
                        <div className="text-wrapper-61">USD 23,000.00</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="frame-70">
                  <div className="text-wrapper-62">7531 4532 6643 5849</div>

                  <img className="img-4" alt="Copy" src="/img/copy.svg" />
                </div>

                {/* <img
                  className="logo-visa-3"
                  alt="Logo visa"
                  src="/img/logo-visa-2.svg"
                /> */}
              </div>
            </div>

            <div className="frame-71">
              <div className="frame-72">
                <svg
                  width={64}
                  height={64}
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width={64}
                    height={64}
                    rx={21.3405}
                    fill="url(#paint0_linear_2627_751)"
                  />
                  <path
                    d="M40.25 43.2485H23.75C21.6823 43.2485 20 41.5662 20 39.4985C20 38.8568 20.1651 38.2233 20.4776 37.6662L28.7255 22.6698C28.727 22.6672 28.7285 22.6646 28.7299 22.662C30.1625 20.1151 33.8369 20.1142 35.2701 22.662C35.2716 22.6645 35.273 22.6672 35.2745 22.6698L43.5225 37.6662C43.8349 38.2233 44 38.8568 44 39.4985C44 41.5662 42.3177 43.2485 40.25 43.2485ZM30.3661 23.5777L22.1185 38.5734C22.117 38.576 22.1156 38.5786 22.1141 38.5812C21.9577 38.8593 21.875 39.1765 21.875 39.4985C21.875 40.5324 22.7161 41.3735 23.75 41.3735H40.25C41.2839 41.3735 42.125 40.5324 42.125 39.4985C42.125 39.1764 42.0423 38.8593 41.8859 38.5812C41.8844 38.5786 41.883 38.576 41.8815 38.5734L33.634 23.5779C32.9164 22.3081 31.0846 22.3067 30.3661 23.5777Z"
                    fill={colors.primario}
                  />
                  <path
                    d="M32 34.811C31.4822 34.811 31.0625 34.3913 31.0625 33.8735V28.2485C31.0625 27.7308 31.4822 27.311 32 27.311C32.5178 27.311 32.9375 27.7308 32.9375 28.2485V33.8735C32.9375 34.3913 32.5178 34.811 32 34.811Z"
                    fill={colors.primario}
                  />
                  <path
                    d="M32 38.561C32.5178 38.561 32.9375 38.1413 32.9375 37.6235C32.9375 37.1058 32.5178 36.686 32 36.686C31.4822 36.686 31.0625 37.1058 31.0625 37.6235C31.0625 38.1413 31.4822 38.561 32 38.561Z"
                    fill={colors.primario}
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2627_751"
                      x1={32}
                      y1={23.9852}
                      x2={32}
                      y2={64}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#efefef" />
                      <stop offset={1} stopColor="#efefef" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                </svg>

                <div className="text-wrapper-63">Missing</div>
              </div>

              <div className="frame-72">
                <svg
                  width={64}
                  height={64}
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width={64}
                    height={64}
                    rx={21.3405}
                    fill="url(#paint0_linear_2627_759)"
                  />
                  <path
                    d="M31.7039 34.7592C31.3117 34.7937 30.7851 34.6787 30.5827 34.4274C30.2347 33.9953 29.6024 33.9273 29.1703 34.2753C28.7383 34.6233 28.6702 35.2556 29.0181 35.6876C29.4021 36.1644 29.9311 36.4564 30.4714 36.6158C30.601 37.0205 30.9804 37.3135 31.4282 37.3135C31.8512 37.3135 32.2132 37.052 32.3612 36.6818C33.3725 36.4352 34.0741 35.7116 34.1968 34.745C34.346 33.57 33.5947 32.4469 32.3696 32.0139C31.6031 31.7429 31.2148 31.584 31.1061 31.5327C30.9563 31.4621 30.9602 31.4096 30.9631 31.3713C30.9707 31.2676 31.0477 31.1711 31.0958 31.1567C31.6548 30.9882 31.9515 31.1621 31.9968 31.2155C32.3159 31.6682 32.9412 31.7772 33.3948 31.459C33.8489 31.1403 33.9586 30.5139 33.64 30.0598C33.3795 29.6887 32.9483 29.3669 32.3953 29.1993C32.2767 28.7767 31.8886 28.4668 31.4281 28.4668C30.9475 28.4668 30.5457 28.8044 30.4469 29.2554C29.6207 29.5361 29.0267 30.3176 28.9596 31.2228C28.8925 32.128 29.3866 32.943 30.2491 33.3497C30.4932 33.4649 31.0221 33.6684 31.7 33.908C32.103 34.0505 32.223 34.3419 32.2039 34.492C32.178 34.6959 31.8457 34.7468 31.7039 34.7592Z"
                    fill={colors.primario}
                  />
                  <path
                    d="M43.3583 32.6156C43.913 32.6156 44.3627 32.1659 44.3627 31.6112V27.5125C44.3627 25.297 42.5603 23.4946 40.3449 23.4946H22.6663C20.4508 23.4946 18.6484 25.297 18.6484 27.5125V38.268C18.6484 40.4834 20.4508 42.2858 22.6663 42.2858H40.3449C42.5603 42.2858 44.3627 40.4834 44.3627 38.268V36.6677C44.3627 36.2642 44.1213 35.8998 43.7496 35.7426L43.6645 35.7066C43.6134 35.685 43.5606 35.6676 43.5066 35.6547C43.1436 35.5679 42.7691 35.524 42.3934 35.524C39.768 35.524 37.6307 37.6542 37.619 40.2769H25.3922C25.3806 37.6674 23.2647 35.5455 20.6574 35.5242V30.3527C23.2718 30.3313 25.3922 28.1978 25.3922 25.5784C25.3922 25.5535 25.392 25.5285 25.3916 25.5036H37.6196C37.6192 25.5285 37.619 25.5535 37.619 25.5784C37.619 28.1978 39.7393 30.3313 42.3538 30.3527V31.6112C42.3538 32.1659 42.8035 32.6156 43.3583 32.6156ZM42.3538 37.5332V38.268C42.3538 39.3757 41.4526 40.2769 40.3449 40.2769H39.628C39.6395 38.7751 40.8542 37.5544 42.3538 37.5332ZM23.3832 40.2769H22.6663C21.5586 40.2769 20.6574 39.3757 20.6574 38.268V37.5332C22.1569 37.5544 23.3717 38.7751 23.3832 40.2769ZM23.3833 25.5784C23.3833 27.0901 22.1641 28.3224 20.6574 28.3436V27.5125C20.6574 26.4048 21.5586 25.5036 22.6663 25.5036H23.3823C23.3829 25.5285 23.3833 25.5535 23.3833 25.5784ZM39.6279 25.5784C39.6279 25.5534 39.6282 25.5285 39.6289 25.5036H40.3449C41.4526 25.5036 42.3538 26.4048 42.3538 27.5125V28.3436C40.8471 28.3224 39.6279 27.0901 39.6279 25.5784Z"
                    fill={colors.primario}
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2627_759"
                      x1={32}
                      y1={23.9852}
                      x2={32}
                      y2={64}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#efefef" />
                      <stop offset={1} stopColor="#efefef" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                </svg>

                <div className="text-wrapper-63">Pay</div>
              </div>

              <div className="frame-72">
                <svg
                  width={64}
                  height={64}
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width={64}
                    height={64}
                    rx={21.3405}
                    fill="url(#paint0_linear_2627_766)"
                  />
                  <g clipPath="url(#clip0_2627_766)">
                    <path
                      d="M39.2254 34.8996C38.8593 34.5335 38.2657 34.5335 37.8996 34.8996L37.625 35.1742L37.3504 34.8996C36.9843 34.5335 36.3907 34.5335 36.0246 34.8996C35.6585 35.2657 35.6585 35.8593 36.0246 36.2254L36.2992 36.5L36.0246 36.7746C35.6585 37.1407 35.6585 37.7343 36.0246 38.1004C36.3907 38.4666 36.9843 38.4666 37.3504 38.1004L37.625 37.8258L37.8996 38.1004C38.2657 38.4666 38.8593 38.4666 39.2254 38.1004C39.5916 37.7343 39.5916 37.1407 39.2254 36.7746L38.9508 36.5L39.2254 36.2254C39.5916 35.8593 39.5916 35.2657 39.2254 34.8996Z"
                      fill={colors.primario}
                    />
                    <path
                      d="M33.6004 34.8996C33.2343 34.5335 32.6407 34.5335 32.2746 34.8996L32 35.1742L31.7254 34.8996C31.3593 34.5335 30.7657 34.5335 30.3996 34.8996C30.0335 35.2657 30.0335 35.8593 30.3996 36.2254L30.6742 36.5L30.3996 36.7746C30.0335 37.1407 30.0335 37.7343 30.3996 38.1004C30.7657 38.4666 31.3593 38.4666 31.7254 38.1004L32 37.8258L32.2746 38.1004C32.6407 38.4666 33.2343 38.4666 33.6004 38.1004C33.9666 37.7343 33.9666 37.1407 33.6004 36.7746L33.3258 36.5L33.6004 36.2254C33.9666 35.8593 33.9666 35.2657 33.6004 34.8996Z"
                      fill={colors.primario}
                    />
                    <path
                      d="M27.9754 34.8996C27.6093 34.5335 27.0157 34.5335 26.6496 34.8996L26.375 35.1742L26.1004 34.8996C25.7343 34.5335 25.1407 34.5335 24.7746 34.8996C24.4085 35.2657 24.4085 35.8593 24.7746 36.2254L25.0492 36.5L24.7746 36.7746C24.4085 37.1407 24.4085 37.7343 24.7746 38.1004C25.1407 38.4666 25.7343 38.4666 26.1004 38.1004L26.375 37.8258L26.6496 38.1004C27.0157 38.4666 27.6093 38.4666 27.9754 38.1004C28.3416 37.7343 28.3416 37.1407 27.9754 36.7746L27.7008 36.5L27.9754 36.2254C28.3416 35.8593 28.3416 35.2657 27.9754 34.8996Z"
                      fill={colors.primario}
                    />
                    <path
                      d="M40.4375 29H38.5625V26.5625C38.5625 22.9439 35.6186 20 32 20C28.3814 20 25.4375 22.9439 25.4375 26.5625V29H23.5625C22.0117 29 20.75 30.2617 20.75 31.8125V41.1875C20.75 42.7383 22.0117 44 23.5625 44H40.4375C41.9883 44 43.25 42.7383 43.25 41.1875V31.8125C43.25 30.2617 41.9883 29 40.4375 29ZM27.3125 26.5625C27.3125 23.9778 29.4153 21.875 32 21.875C34.5847 21.875 36.6875 23.9778 36.6875 26.5625V29H27.3125V26.5625ZM41.375 41.1875C41.375 41.7044 40.9544 42.125 40.4375 42.125H23.5625C23.0456 42.125 22.625 41.7044 22.625 41.1875V31.8125C22.625 31.2956 23.0456 30.875 23.5625 30.875H40.4375C40.9544 30.875 41.375 31.2956 41.375 31.8125V41.1875Z"
                      fill={colors.primario}
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_2627_766"
                      x1={32}
                      y1={23.9852}
                      x2={32}
                      y2={64}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#efefef" />
                      <stop offset={1} stopColor="#efefef" stopOpacity={0} />
                    </linearGradient>
                    <clipPath id="clip0_2627_766">
                      <rect
                        width={24}
                        height={24}
                        fill="white"
                        transform="translate(20 20)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="text-wrapper-63">PIN</div>
              </div>

              <div className="frame-72">
                <svg
                  width={65}
                  height={65}
                  viewBox="0 0 65 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width={64.0214}
                    height={64.0214}
                    rx={21.3405}
                    fill="url(#paint0_linear_2627_775)"
                  />
                  <g clipPath="url(#clip0_2627_775)">
                    <path
                      d="M32.9482 37.542C32.9482 38.0598 32.5285 38.4795 32.0107 38.4795H26.4795C25.9617 38.4795 25.542 38.0598 25.542 37.542C25.542 37.0242 25.9617 36.6045 26.4795 36.6045H32.0107C32.5285 36.6045 32.9482 37.0242 32.9482 37.542ZM44.0107 25.6428V36.6201C44.0107 38.0595 43.4502 39.4127 42.4324 40.4305L40.4305 42.4324C39.4127 43.4502 38.0595 44.0107 36.6201 44.0107H25.6428C22.5298 44.0107 20.0107 41.4914 20.0107 38.3787V25.6428C20.0107 22.5298 22.53 20.0107 25.6428 20.0107H38.3787C41.4917 20.0107 44.0107 22.53 44.0107 25.6428ZM42.01 37.5576H39.4326C38.3987 37.5576 37.5576 38.3987 37.5576 39.4326V42.01C38.1371 41.8506 38.6682 41.5431 39.1047 41.1066L41.1066 39.1047C41.5431 38.6682 41.8506 38.1371 42.01 37.5576ZM42.1357 25.6428C42.1357 23.5662 40.4552 21.8857 38.3787 21.8857H25.6428C23.5662 21.8857 21.8857 23.5663 21.8857 25.6428V38.3787C21.8857 40.4553 23.5663 42.1357 25.6428 42.1357H35.6826V39.4326C35.6826 37.3649 37.3649 35.6826 39.4326 35.6826H42.1357V25.6428ZM37.542 31.0732H26.4795C25.9617 31.0732 25.542 31.493 25.542 32.0107C25.542 32.5285 25.9617 32.9482 26.4795 32.9482H37.542C38.0598 32.9482 38.4795 32.5285 38.4795 32.0107C38.4795 31.493 38.0598 31.0732 37.542 31.0732ZM37.542 25.542H26.4795C25.9617 25.542 25.542 25.9617 25.542 26.4795C25.542 26.9973 25.9617 27.417 26.4795 27.417H37.542C38.0598 27.417 38.4795 26.9973 38.4795 26.4795C38.4795 25.9617 38.0598 25.542 37.542 25.542Z"
                      fill={colors.primario}
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_2627_775"
                      x1={32.0107}
                      y1={23.9932}
                      x2={32.0107}
                      y2={64.0215}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#efefef" />
                      <stop offset={1} stopColor="#efefef" stopOpacity={0} />
                    </linearGradient>
                    <clipPath id="clip0_2627_775">
                      <rect
                        width={24}
                        height={24}
                        fill="white"
                        transform="translate(20.0107 20.0107)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="text-wrapper-63">Statements</div>
              </div>

              {/* <div className="frame-72">
                <img
                  className="frame-74"
                  alt="Frame"
                  src="/img/frame-480954776.svg"
                />

                <div className="text-wrapper-63">Installments</div>
              </div> */}

              {/* <div className="frame-72">
                <svg
                  width={64}
                  height={64}
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width={64}
                    height={64}
                    rx={21.3405}
                    fill="url(#paint0_linear_2627_751)"
                  />
                  <path
                    d="M40.25 43.2485H23.75C21.6823 43.2485 20 41.5662 20 39.4985C20 38.8568 20.1651 38.2233 20.4776 37.6662L28.7255 22.6698C28.727 22.6672 28.7285 22.6646 28.7299 22.662C30.1625 20.1151 33.8369 20.1142 35.2701 22.662C35.2716 22.6645 35.273 22.6672 35.2745 22.6698L43.5225 37.6662C43.8349 38.2233 44 38.8568 44 39.4985C44 41.5662 42.3177 43.2485 40.25 43.2485ZM30.3661 23.5777L22.1185 38.5734C22.117 38.576 22.1156 38.5786 22.1141 38.5812C21.9577 38.8593 21.875 39.1765 21.875 39.4985C21.875 40.5324 22.7161 41.3735 23.75 41.3735H40.25C41.2839 41.3735 42.125 40.5324 42.125 39.4985C42.125 39.1764 42.0423 38.8593 41.8859 38.5812C41.8844 38.5786 41.883 38.576 41.8815 38.5734L33.634 23.5779C32.9164 22.3081 31.0846 22.3067 30.3661 23.5777Z"
                    fill={colors.primario}
                  />
                  <path
                    d="M32 34.811C31.4822 34.811 31.0625 34.3913 31.0625 33.8735V28.2485C31.0625 27.7308 31.4822 27.311 32 27.311C32.5178 27.311 32.9375 27.7308 32.9375 28.2485V33.8735C32.9375 34.3913 32.5178 34.811 32 34.811Z"
                    fill={colors.primario}
                  />
                  <path
                    d="M32 38.561C32.5178 38.561 32.9375 38.1413 32.9375 37.6235C32.9375 37.1058 32.5178 36.686 32 36.686C31.4822 36.686 31.0625 37.1058 31.0625 37.6235C31.0625 38.1413 31.4822 38.561 32 38.561Z"
                    fill={colors.primario}
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2627_751"
                      x1={32}
                      y1={23.9852}
                      x2={32}
                      y2={64}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#efefef" />
                      <stop offset={1} stopColor="#efefef" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                </svg>

                <div className="text-wrapper-63">Limits</div>
              </div> */}

              {/* <div className="frame-72">
                <img
                  className="frame-74"
                  alt="Frame"
                  src="/img/frame-480954775-1.png"
                />

                <div className="text-wrapper-63">Cash out</div>
              </div> */}

              {/* <div className="frame-72">
                <img
                  className="frame-74"
                  alt="Frame"
                  src="/img/frame-480954775-2.png"
                />

                <div className="text-wrapper-63">Promos</div>
              </div> */}
            </div>

            <div className="element">
              <div className="subsection-2">
                <div className="frame-75">
                  <div className="text-wrapper-64">Last card activity</div>
                </div>

                <div className="frame-76">
                  <div className="btn-text-link-3">
                    <div className="text-link">See all</div>
                  </div>

                  <TrailingIcon14
                    className="trailing-icon-14"
                    color="var(--secundario)"
                  />
                </div>
              </div>

              <div className="frame-77">
                <div className="feed-row">
                  <div className="data">
                    <svg
                      width={48}
                      height={49}
                      viewBox="0 0 48 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y={0.0214844}
                        width={48}
                        height={48}
                        rx={18}
                        fill="#efefef"
                      />
                      <g clipPath="url(#clip0_2627_824)">
                        <path
                          d="M32.0155 21.5156C29.8186 21.5156 28.0312 19.7093 28.0312 17.489C28.0312 15.7876 28.259 12.9799 28.2687 12.8612C28.3108 12.3452 28.764 11.9613 29.2794 12.0032C29.7954 12.0453 30.1796 12.4979 30.1375 13.0139C30.1352 13.0422 29.9062 15.8645 29.9062 17.489C29.9062 18.6754 30.8524 19.6406 32.0155 19.6406C33.1787 19.6406 34.1249 18.6754 34.1249 17.489C34.1249 15.8633 33.896 13.0422 33.8936 13.0139C33.8515 12.4979 34.2356 12.0453 34.7517 12.0032C35.2672 11.9608 35.7203 12.3451 35.7624 12.8612C35.7721 12.9799 35.9999 15.7876 35.9999 17.489C35.9999 19.7093 34.2125 21.5156 32.0155 21.5156ZM32.953 16.5469V12.9375C32.953 12.4198 32.5333 12.0001 32.0155 12.0001C31.4978 12.0001 31.0781 12.4198 31.0781 12.9375V16.5469C31.0781 17.0647 31.4978 17.4844 32.0155 17.4844C32.5333 17.4844 32.953 17.0647 32.953 16.5469ZM28.9812 34.9317C29.4527 34.7177 29.6614 34.162 29.4473 33.6905C29.2333 33.2191 28.6776 33.0104 28.2061 33.2245C26.9085 33.8136 25.4541 34.125 24 34.125C18.417 34.125 13.875 29.583 13.875 24.0001C13.875 18.4171 18.417 13.8751 24 13.8751C24.4598 13.8751 24.9221 13.9062 25.374 13.9674C25.8868 14.0369 26.3594 13.6775 26.429 13.1644C26.4986 12.6514 26.139 12.179 25.6259 12.1095C25.0909 12.0369 24.5438 12.0001 24 12.0001C20.7947 12.0001 17.7812 13.2483 15.5147 15.5148C13.2482 17.7813 12 20.7948 12 24.0001C12 27.2054 13.2482 30.2188 15.5147 32.4853C17.7812 34.7518 20.7947 36 24 36C25.7195 36 27.4421 35.6306 28.9812 34.9317ZM24.2003 31.4509C24.718 31.4387 25.1276 31.0091 25.1154 30.4915C25.1032 29.9739 24.6749 29.5648 24.1559 29.5765C24.1113 29.5775 24.0668 29.578 24.0223 29.578C21.0197 29.578 18.5418 27.1723 18.4703 24.1549C18.4351 22.6716 18.9798 21.2633 20.0038 20.1896C21.0279 19.1158 22.409 18.5051 23.8925 18.4699C24.3423 18.4594 24.8395 18.5149 25.3313 18.6311C25.8356 18.7502 26.3402 18.4381 26.4592 17.9342C26.5783 17.4303 26.2663 16.9253 25.7624 16.8063C25.1171 16.6539 24.455 16.5807 23.8481 16.5954C21.8639 16.6424 20.0168 17.4593 18.647 18.8954C17.2773 20.3316 16.5488 22.2152 16.5959 24.1993C16.6916 28.2354 20.0054 31.453 24.0217 31.453C24.0809 31.4531 24.1409 31.4524 24.2003 31.4509ZM32.953 35.0625V24.3281C32.953 23.8104 32.5333 23.3906 32.0155 23.3906C31.4978 23.3906 31.0781 23.8104 31.0781 24.3281V35.0625C31.0781 35.5802 31.4978 36 32.0155 36C32.5333 36 32.953 35.5802 32.953 35.0625Z"
                          fill={colors.primario}
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2627_824">
                          <rect
                            width={24}
                            height={24}
                            fill="white"
                            transform="translate(12 12)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <div className="group-13">
                      <div className="overlap-group-19">
                        <div className="name">Starbucks coffee time</div>

                        <div className="subject-wrapper">
                          <div className="subject">6 h ago</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="frame-79">
                    <div className="amount-6">- $25.11</div>
                    <svg
                      class="trailing-icon-14 trailing-icon-14"
                      fill="none"
                      height="19"
                      viewBox="0 0 18 19"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="path"
                        d="M6.75 14.1602L11.25 9.66016L6.75 5.16016"
                        stroke="var(--secundario)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></path>
                    </svg>
                  </div>
                </div>

                <div className="feed-row">
                  <div className="data">
                    <svg
                      width={48}
                      height={49}
                      viewBox="0 0 48 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y={0.0214844}
                        width={48}
                        height={48}
                        rx={18}
                        fill="#efefef"
                      />
                      <g clipPath="url(#clip0_2627_824)">
                        <path
                          d="M32.0155 21.5156C29.8186 21.5156 28.0312 19.7093 28.0312 17.489C28.0312 15.7876 28.259 12.9799 28.2687 12.8612C28.3108 12.3452 28.764 11.9613 29.2794 12.0032C29.7954 12.0453 30.1796 12.4979 30.1375 13.0139C30.1352 13.0422 29.9062 15.8645 29.9062 17.489C29.9062 18.6754 30.8524 19.6406 32.0155 19.6406C33.1787 19.6406 34.1249 18.6754 34.1249 17.489C34.1249 15.8633 33.896 13.0422 33.8936 13.0139C33.8515 12.4979 34.2356 12.0453 34.7517 12.0032C35.2672 11.9608 35.7203 12.3451 35.7624 12.8612C35.7721 12.9799 35.9999 15.7876 35.9999 17.489C35.9999 19.7093 34.2125 21.5156 32.0155 21.5156ZM32.953 16.5469V12.9375C32.953 12.4198 32.5333 12.0001 32.0155 12.0001C31.4978 12.0001 31.0781 12.4198 31.0781 12.9375V16.5469C31.0781 17.0647 31.4978 17.4844 32.0155 17.4844C32.5333 17.4844 32.953 17.0647 32.953 16.5469ZM28.9812 34.9317C29.4527 34.7177 29.6614 34.162 29.4473 33.6905C29.2333 33.2191 28.6776 33.0104 28.2061 33.2245C26.9085 33.8136 25.4541 34.125 24 34.125C18.417 34.125 13.875 29.583 13.875 24.0001C13.875 18.4171 18.417 13.8751 24 13.8751C24.4598 13.8751 24.9221 13.9062 25.374 13.9674C25.8868 14.0369 26.3594 13.6775 26.429 13.1644C26.4986 12.6514 26.139 12.179 25.6259 12.1095C25.0909 12.0369 24.5438 12.0001 24 12.0001C20.7947 12.0001 17.7812 13.2483 15.5147 15.5148C13.2482 17.7813 12 20.7948 12 24.0001C12 27.2054 13.2482 30.2188 15.5147 32.4853C17.7812 34.7518 20.7947 36 24 36C25.7195 36 27.4421 35.6306 28.9812 34.9317ZM24.2003 31.4509C24.718 31.4387 25.1276 31.0091 25.1154 30.4915C25.1032 29.9739 24.6749 29.5648 24.1559 29.5765C24.1113 29.5775 24.0668 29.578 24.0223 29.578C21.0197 29.578 18.5418 27.1723 18.4703 24.1549C18.4351 22.6716 18.9798 21.2633 20.0038 20.1896C21.0279 19.1158 22.409 18.5051 23.8925 18.4699C24.3423 18.4594 24.8395 18.5149 25.3313 18.6311C25.8356 18.7502 26.3402 18.4381 26.4592 17.9342C26.5783 17.4303 26.2663 16.9253 25.7624 16.8063C25.1171 16.6539 24.455 16.5807 23.8481 16.5954C21.8639 16.6424 20.0168 17.4593 18.647 18.8954C17.2773 20.3316 16.5488 22.2152 16.5959 24.1993C16.6916 28.2354 20.0054 31.453 24.0217 31.453C24.0809 31.4531 24.1409 31.4524 24.2003 31.4509ZM32.953 35.0625V24.3281C32.953 23.8104 32.5333 23.3906 32.0155 23.3906C31.4978 23.3906 31.0781 23.8104 31.0781 24.3281V35.0625C31.0781 35.5802 31.4978 36 32.0155 36C32.5333 36 32.953 35.5802 32.953 35.0625Z"
                          fill={colors.primario}
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2627_824">
                          <rect
                            width={24}
                            height={24}
                            fill="white"
                            transform="translate(12 12)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <div className="group-13">
                      <div className="overlap-group-19">
                        <div className="name">Bruno’s tricks</div>

                        <div className="subject-wrapper">
                          <div className="subject">11/06/24</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="feed-row-2">
                    <div className="data">
                      <img
                        className="frame-78"
                        alt="Frame"
                        src="/img/frame-480954772-1.svg"
                      />

                      <div className="group-13">
                        <div className="overlap-group-19">
                          <div className="name">Bruno’s tricks</div>

                          <div className="subject-wrapper">
                            <div className="subject">11/06/24</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="frame-79">
                      <div className="amount-6">- $12.42</div>

                      <img
                        className="img-4"
                        alt="Btn icon chevron"
                        src="/img/btn-icon-chevron-9.svg"
                      />
                    </div>
                  </div> */}
                </div>

                <div className="feed-row">
                  <div className="data">
                    <svg
                      width={48}
                      height={49}
                      viewBox="0 0 48 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y={0.0214844}
                        width={48}
                        height={48}
                        rx={18}
                        fill="#efefef"
                      />
                      <path
                        d="M33.0936 34.0811L31.7549 19.1725C31.7184 18.7653 31.3772 18.4535 30.9684 18.4535H28.2077V17.2084C28.2077 14.8879 26.32 13 23.9996 13C21.6793 13 19.7917 14.8879 19.7917 17.2084V18.4535H17.0291C16.6204 18.4535 16.2792 18.7653 16.2426 19.1725L14.8987 34.1397C14.8789 34.3606 14.9528 34.5795 15.1024 34.7431C15.252 34.9067 15.4635 34.9999 15.6852 34.9999H32.3125C32.3132 34.9999 32.314 34.9999 32.3146 34.9999C32.7508 34.9999 33.1043 34.6463 33.1043 34.2102C33.1042 34.1663 33.1006 34.1231 33.0936 34.0811ZM21.371 17.2084C21.371 15.7587 22.5502 14.5793 23.9997 14.5793C25.4493 14.5793 26.6286 15.7587 26.6286 17.2084V18.4535H21.371V17.2084ZM16.5489 33.4207L17.7511 20.0328H19.7917V21.4449C19.7917 21.881 20.1452 22.2345 20.5814 22.2345C21.0176 22.2345 21.371 21.881 21.371 21.4449V20.0328H26.6286V21.4449C26.6286 21.881 26.982 22.2345 27.4182 22.2345C27.8544 22.2345 28.2078 21.881 28.2078 21.4449V20.0328H30.2466L31.4488 33.4207H16.5489Z"
                        fill={colors.primario}
                      />
                    </svg>

                    <div className="group-13">
                      <div className="overlap-group-19">
                        <div className="name">New gymn shoes</div>

                        <div className="subject-wrapper">
                          <div className="subject">11/06/24</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="frame-80">
                    <div className="amount-6">- $158.68</div>

                    <svg
                      class="trailing-icon-14 trailing-icon-14"
                      fill="none"
                      height="19"
                      viewBox="0 0 18 19"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="path"
                        d="M6.75 14.1602L11.25 9.66016L6.75 5.16016"
                        stroke="var(--secundario)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></path>
                    </svg>
                  </div>
                </div>

                <div className="feed-row">
                  <div className="data">
                    <img
                      className="frame-78"
                      alt="Frame"
                      src="/img/frame-480954772-3.svg"
                    />

                    <div className="group-13">
                      <div className="overlap-group-19">
                        <div className="name">Card payment</div>

                        <div className="subject-wrapper">
                          <div className="subject">11/06/24</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="amount-wrapper">
                    <div className="amount-7">$950.23</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <img
            className="atomo-numb-token"
            alt="Atomo numb token"
            src="/img/atomo-numb-token.svg"
          /> */}
        </div>

        <img className="intersect" alt="Intersect" src="/img/intersect.png" />
      </div>
    </div>
  );
};
